import type {
	DatovkaApiType,
	DatoveSchrankyDatovaZpravaDto,
} from '@gov-nx/api';
import type { MySubmissionConnection } from '@gov-nx/core/hooks';
import type { Nullable, Optional } from '@gov-nx/core/types';
import type { IUseBoolean } from '@gov-nx/utils/common';
import type {
	DataBoxConfirmModalType,
	DataBoxFolderType,
} from './DataBoxes.types';

export type DataBoxMessageDetailContextType = {
	dataBoxId: string;
	dataBox: Optional<DatovkaApiType>;
	recipientDataBox?: DatovkaApiType;
	senderDataBox?: DatovkaApiType;
	folderType: DataBoxFolderType;
	messageId: number;
	message: Optional<DatoveSchrankyDatovaZpravaDto>;
	isLoading: boolean;
	loadingItems: Partial<Record<DataBoxMessageDetailLoadingItemType, boolean>>;
	messageOperations: {
		isLoading: boolean;
		isArchivingEnabled: boolean;
		handleArchiveMessage: () => void;
		handleRestoreMessage: (redirect: () => void) => void;
		handleDeleteMessage: (permanently: boolean, redirect: () => void) => void;
		handleDeleteMessageFromVault: (
			direction: 'ODESLANA' | 'PRIJATA',
			redirect: () => void
		) => void;
		handleDownloadMessage: (message: DatoveSchrankyDatovaZpravaDto) => void;
		handleSaveAllAttachmentsToDocuments: (
			message: DatoveSchrankyDatovaZpravaDto
		) => void;
	};
	confirmModal: Nullable<DataBoxConfirmModalType>;
	setConfirmModal: (modal: Nullable<DataBoxConfirmModalType>) => void;
	vaultConfirmModal: IUseBoolean;
	showAllAttachments: boolean;
	setShowAllAttachments: (showAll: boolean) => void;
	disableNewMessageButton: boolean;
	mySubmissionConnection: MySubmissionConnection;
};

export enum DataBoxMessageDetailLoadingItemType {
	Archive = 'archive',
	Restore = 'restore',
	Download = 'download',
	Remove = 'remove',
	RemovePermanently = 'removePermanently',
	SaveAttachmentsToDocuments = 'saveAttachmentsToDocuments',
	DeleteFromVault = 'deleteFromVault',
}
